module.exports = __webpack_public_path__ + "img/kuangjiao_xc5.c496b657.jpg";